import { StyledButton } from "@insite/mobius/Clickable";
import { IconWrapper } from "@insite/mobius/Icon";
import { MenuPresentationProps } from "@insite/mobius/Menu";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

export const menu: {
    defaultProps?: MenuPresentationProps | undefined;
} = {
    defaultProps: {
        menuItemClickableProps: {
            css: css`
            position: relative;
                ${mediaQueriesBP.minLG} {
                    &&& {
                        min-height: 32px;
                    }
                }
            `,
        },
        menuItemTypographyProps: {
            size: "14px",
            lineHeight: "16px",
            css: css`
                ${mediaQueriesBP.minLG} {
                    &&& {
                        padding: 8px 20px;
                    }
                }
            `,
        },
        cssOverrides: {
            menuItem: css`
                ${TypographyStyle} {
                    color: ${getColor(colorStrings.secondaryMain)};
                }

                ${IconWrapper} {
                    color: ${getColor(colorStrings.secondaryMain)};
                    top: 50%;
                    transform: translateY(-50%);
                }

                &:hover {
                    & > ${StyledButton} {
                        background: ${getColor(colorStrings.commonGlobalExtraLight)};

                        & > ${TypographyStyle} {
                            text-decoration: underline;
                        }
                    }
                }
            `,
        },
    },
};
